import React from 'react';

import { BoxContainer } from '../../components';
import AddInvoiceForm from './components/AddInvoiceForm';

const PageContent = () => {
  return (
    <BoxContainer $useMarginBottom $useMarginTop>
      <AddInvoiceForm />
    </BoxContainer>
  );
};

export default PageContent;
